<template>
  <div>
    <div :id="VIEW_LIST" v-if="viewType == VIEW_LIST">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>
                <div class="box-tools">
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:right;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:right;">Total Amount</th>                    
                    <th style="text-align:center;">Currency</th>                    
                    <th style="text-align:center;">Status</th>
                    <th style="text-align:left;">Project</th>
                    <th style="text-align:left;">Bank Account</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:45px;text-align:center;">
                      <input type="checkbox" :id="row.id" :value="row.id" v-model="checkedPayments" @change="onCheckedPayment">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                    </td>
                    <td style="text-align:left;" nowrap>{{ row.name }}</td>
                    <td style="text-align:right;" nowrap>{{ row.total_amount }}</td>                    
                    <td style="text-align:center;" nowrap>{{ row.currency_name }}</td>
                    <td style="text-align:center;">
                      <span v-if="row.status == SESSION_CLEARED" class="badge bg-blue">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_POSTED" class="badge bg-green">{{ row.status }}</span>
                      <span v-if="row.status == SESSION_REVERSED" class="badge bg-red">{{ row.status }}</span>
                    </td>
                    <td style="text-align:left;" nowrap>{{ row.project_name }}</td>
                    <td style="text-align:left;" nowrap>{{ row.bank_account_name }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.currency_id }}</td> 
                    <td hidden>{{ row.project_id }}</td>
                    <td hidden>{{ row.bank_account_id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
                <button v-on:click="onReverse" class="btn btn-primary pull-right">Reverse</button>
                <button v-on:click="onPostIncoming" class="btn btn-primary pull-right" style="margin-right:5px;">Post Incoming</button>
                <button v-on:click="onPostDeposit" class="btn btn-primary pull-right" style="margin-right:5px;">Post Deposit</button>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div> 

    <div id="postingDate" style="display:none;">

    </div>

  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const VIEW_LIST = 'list'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
// const MODE_UPDATE = 'update'
const SESSION_CLEARED = 'Cleared'
const SESSION_POSTED = 'Posted'
const SESSION_REVERSED = 'Reversed'

export default {
  name: 'PaymentClearing',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_LIST: VIEW_LIST,
      SESSION_CLEARED: SESSION_CLEARED,
      SESSION_POSTED: SESSION_POSTED,
      SESSION_REVERSED: SESSION_REVERSED,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'name',
        WhereClauseByProject: ''
      },
      viewType: VIEW_LIST,
      checkedPayments: [],
      postingDate: ''
    }
  },
  computed: {
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryPaymentClearingSessionByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      var keyWords = evt.target.value
      var whereClause = ['name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Payment', 'get', '/api/Payment/InquiryClearingPayment?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreate() {
      let params = {
        id: 0,
        mode: MODE_CREATE
      }
      this.$router.push({ name: 'PaymentClearing', params: params })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }
      this.$router.push({ name: 'PaymentClearingSession', params: params })
    },
    onCheckedPayment() {
    },
    onPostDeposit() {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'This process will post payment as deposit money in SAP',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          this.postDeposit()
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          // SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    postDeposit() {
      api
        .request('Payment', 'post', '/api/Payment/PostDeposit', this.checkedPayments)
        .then(response => {
          if (response.data.returnStatus) {
            SweetAlert.fire('Success', response.data.returnMessage.join('<br>'), 'success')
          } else {
            SweetAlert.fire('Error', response.data.returnMessage.join('<br>'), 'error')
          }
        })
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    },
    onPostIncoming() {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'This process will post payment as incoming payment in SAP',
        // html: '<p>This process will post payment as incoming payment in SAP</p> <div id="postingDateSwal"></div>',
        input: 'text',
        inputPlaceholder: 'Enter posting date in format dd.MM.yyyy',
        customClass: 'swal2-overflow',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        onOpen: function() {
          $('.swal2-input').val(moment(new Date()).format('DD.MM.YYYY'))
        }
      })
      .then((result) => {
        if (result.value) {
          let postingDate = $('.swal2-input').val()
          this.postIncoming(postingDate)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          // SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    postIncoming(postingDate) {
      var reqData = {
        paymentClearingSessionIds: this.checkedPayments,
        postingDate: postingDate
      }

      api
        .request('Payment', 'post', '/api/Payment/PostIncoming', reqData)
        .then(response => {
          if (response.data.returnStatus) {
            SweetAlert.fire('Success', response.data.returnMessage.join('<br>'), 'success')
          } else {
            SweetAlert.fire('Error', response.data.returnMessage.join('<br>'), 'error')
          }
        })
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    },
    onReverse() {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'This process will reverse this payment clearing and automatically will reverse accounting doc in SAP',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          this.reverse()
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
        }
      })
    },
    reverse() {
      api
        .request('Payment', 'post', '/api/Payment/Clearing/Reverse', this.checkedPayments)
        .then(response => {
          if (response.data.returnStatus) {
            SweetAlert.fire('Success', response.data.returnMessage.join('<br>'), 'success')
          } else {
            SweetAlert.fire('Error', response.data.returnMessage.join('<br>'), 'error')
          }
        })
        .catch(error => {
          SweetAlert.fire('Error', error.message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
.swal2-overflow {
  overflow-x: visible;
  overflow-y: visible;
}
</style>



// WEBPACK FOOTER //
// PaymentClearingSession.vue?4e8e91b0